import Route from '@ember/routing/route';

export default class Contact extends Route {
  // normal class body definition here
}
